import {
  InitClient,
  GetByParas,
  Post,
  PostWithParas,
  PostNoParas
} from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { PagingBody } from "../Model/PagingBody";

InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);
// //更新节点
// async function UpdateNode(nodeid,node){
//     var paras={
//         ID:nodeid
//     }
//     var data=await PostWithParas('124e7806-0d3e-4196-b15c-d3e69a54557c',paras,node);
//     data=data.replace("\"", "");
//     if(data=='success'){
//         return true;
//     }
//     else{
//         return false;
//     }
// }

/**
 * 添加表单信息
 * @param {*} Informations 
 */
async function InformationsAdd(Informations) {
  var data = await Post("67368579-259b-4381-b93d-f93d30e8f0a5", Informations);
  // data = data.replace("\"", "");
  if (data.Result == "success") {
    return data;
  } else {
    return false;
  }
}

/**
 * 添加表单信息
 * @param {*} Material 
 */
async function MaterialAdd(Material) {
  var data = await Post("942638a7-bc1d-42cd-8ef0-3bc63e17c0d3", Material);
  // data = data.replace("\"", "");
  if (data.Result == "success") {
    return data;
  } else {
    return false;
  }
}

/**
 * 获取发送时的下面步骤集合
 * @param {*} userid 
 * @param {*} stepid 
 * @param {*} instanceid 
 */ 
async function GetFlowSendNextSteps(userid, stepid, instanceid) {
  var paras = {
    userid: userid,
    flowid: "44cae30c-23a0-4f36-aa34-914350682380",
    stepid: stepid,
    instanceid: instanceid
  };
  return await GetByParas("6704feb2-2301-4f60-ab98-4ffb0e3215f0", paras);
}

/**
 * 添加退款流程审批
 * @param {*} paras 
 */
async function Excuteflow(paras) {
  var data = await Post("57871b3f-7b02-4179-9b3e-c40d44ff7eeb", paras);
  // data = data.replace("\"", "");
  if (data.result == "1") {
    return data;
  } else {
    return false;
  }
}

/**
 * 添加退款流程审批
 * @param {*} paras 
 */
async function Finshflow(paras) {
  var data = await Post("4b5029d6-fbd8-48bf-9395-3704f16a70ec", paras);
  if (data.result == "1") {
    return data;
  } else {
    return false;
  }
}

/**
 * 添加退款流程审批
 * @param {*} paras 
 */
async function Refuse(paras) {
  var data = await Post("edbe46b4-577d-468c-9bb0-ab192eb251d5", paras);
  // data = data.replace("\"", "");
  if (data.result == "1") {
    return data;
  } else {
    return false;
  }
}

/**
 * 获取我发起的审批
 * @param {*} userid 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 * @param {*} searchInstance 
 */
async function GetUserCeate(userid, pageIndex, pageSize, searchInstance) {
  var paras = {
    userid: userid,
    flowId: "44cae30c-23a0-4f36-aa34-914350682380",
    pageIndex: pageIndex,
    pageSize: pageSize
  };
  var data = await PostWithParas(
    "90e7857c-8bd3-4e00-aaa7-31f2af071941",
    paras,
    searchInstance
  );
  return data;
}

/**
 * 查询我发起的申请
 * @param {*} Search 
 */
async function GetInformationId(Search) {
  var paras = {
    Search: Search
  };
  return await GetByParas("848d3e61-09b7-45b5-ab37-dae57da085fb", paras);
}


/**
 * GetInformationListForIds
 * @param {*} paras 
 */
async function GetInformationListForIds(paras) {
  var data = await Post("edb72b00-f5a0-4415-b1e2-45aab3cffbc7", paras);
  return data;
}

/**
 * 获取步骤时间线
 * @param {*} userid 
 * @param {*} instanceid 
 */
async function GetStepTimeLine(userid, instanceid) {
  var paras = {
    userid: userid,
    flowId: "44cae30c-23a0-4f36-aa34-914350682380",
    stepid: "ee796122-1337-4b0e-8c0c-22d8d1dd7e70",
    instanceid: instanceid
  };
  return await GetByParas("2aa9da6e-aaec-4987-bcc9-fb0120aa1659", paras);
}

/**
 * 根据编号获取详情
 * @param {*} Id 
 */
async function GetInformation(Id) {
  var paras = {
    Id: Id
  };
  return await GetByParas("5e47302a-4b83-45ed-b8f3-ec672ffac675", paras);
}
/**
 * 撤销退款申请
 * @param {*} taskid 
 * @param {*} flowid 
 * @param {*} instanceid 
 * @param {*} stepid 
 */
async function Cancel(taskid, flowid, instanceid, stepid) {
  var paras = {
    taskid: taskid,
    flowid: flowid,
    instanceid: instanceid,
    stepid: stepid
  };
  var data = await PostWithParas(
    "fab77c72-fd00-4796-bc07-3a433b538aea",
    paras,
    ""
  );
  if (data.result == 1) {
    return data;
  } else {
    return false;
  }
}
/**
 * 撤回后更新表单信息状态
 * @param {*} id 
 */
async function UpdateRefundStatus(id) {
  var paras = {
    id: id,
    refundStatus: -1
  };
  var data = await PostWithParas(
    "a656ddd8-b735-4a09-85a5-8665e6f8aacc",
    paras,
    ""
  );
  if (data == "success") {
    return data;
  } else {
    return false;
  }
}

/**
 * 获取待办事项(待审批)
 * @param {*} userid 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 * @param {*} Instance 
 */
async function GetWaitTasks(userid, pageIndex, pageSize, Instance) {
  var paras = {
    userid: userid,
    flowId: "44cae30c-23a0-4f36-aa34-914350682380",
    pageIndex: pageIndex,
    pageSize: pageSize
  };
  var data = await PostWithParas(
    "f1001200-1c14-4e68-ba05-388dad7857f1",
    paras,
    Instance
  );
  return data;
}

/**
 * 我处理的审批(我已审批)
 * @param {*} userid 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 * @param {*} Instance 
 */
async function GetUserDeal(userid, pageIndex, pageSize, Instance) {
  var paras = {
    userid: userid,
    flowId: "44cae30c-23a0-4f36-aa34-914350682380",
    pageIndex: pageIndex,
    pageSize: pageSize
  };
  var data = await PostWithParas(
    "3aed5420-68cb-42e6-9b21-f9ebe2b20edd",
    paras,
    Instance
  );
  return data;
}

/**
 * 抄送我的
 * @param {*} userid 
 * @param {*} pageIndex 
 * @param {*} pageSize 
 */
async function GetCCUser(userid, pageIndex, pageSize) {
  var paras = {
    userid: userid,
    flowId: "44cae30c-23a0-4f36-aa34-914350682380",
    pageIndex: pageIndex,
    pageSize: pageSize
  };
  var data = await PostWithParas(
    "624b3e63-9aac-46b1-97cd-e76d7e57facd",
    paras,
    []
  );
  return data;
 
}

/**
 * 转交
 * @param {*} userName 
 * @param {*} ReceiveName 
 * @param {*} taskid 
 * @param {*} userid 
 * @param {*} reason 
 */
async function HandOverOper(userName, ReceiveName, taskid, userid, reason) {
  var paras = {
    userName: userName,
    ReceiveName: ReceiveName,
    taskid: taskid,
    userid: userid,
    reason: reason
  };
  return await GetByParas("550c7247-5e6d-41d0-b10d-047975087739", paras);
}

/**
 * 根据公司名称获取是否已开户
 * @param {*} companyName 
 */
async function GetIsOpen(companyName) {
  var paras = {
    companyName: companyName
  };
  return await GetByParas("a992ae70-2d4e-479e-a083-4a25b85bdf36", paras);
}

/**
 * 根据公司名称获取是否为未消费
 * @param {*} companyName 
 */
async function GetRefund(companyName) {
  var paras = {
    companyName: companyName
  };
  return await GetByParas("23f6a743-9b54-4a2e-97d2-26c4f778adad", paras);
}

/**
 * 获取已消费金额
 * @param {*} accountName 
 * @param {*} refundType 0大搜 1信息流
 */
async function GetBalanceMoney(accountName,refundType) {
  var paras = {
    accountName: accountName,
    refundType: refundType
  };
  return await GetByParas("d8e91c4c-ff70-4d98-8d72-547a301d7bd9", paras);
}

/**
 * 预存款是否消费完毕
 * @param {*} accountName 
 * @param {*} refundType 
 */
async function GetIsOk(accountName,refundType) {
  var paras = {
    accountName: accountName,
    refundType: refundType
  };
  return await GetByParas("c2a31c18-fd10-4be6-bc3f-7f4e6a110322", paras);
}

/**
 * 根据账户名称获取扣减信息
 * @param {Object} accountName
 * @param {Object} RefundStyle
 * @param {Object} RefundMoney
 */
async function Getkoujian(accountName,RefundStyle,RefundMoney) {
  var paras = {
    accountName: accountName,
    RefundStyle: RefundStyle,
		RefundMoney: RefundMoney
  };
  return await GetByParas("745b69fc-2731-4c9f-8ce2-e8f1285e78c0", paras);
}
export {
  InformationsAdd,
  MaterialAdd,
  GetFlowSendNextSteps,
  Excuteflow,
  GetUserCeate,
  GetInformationId,
  GetInformationListForIds,
  GetStepTimeLine,
  GetInformation,
  Cancel,
  UpdateRefundStatus,
  GetWaitTasks,
  GetUserDeal,
  GetCCUser,
  HandOverOper,
  GetIsOpen,
  GetRefund,
  GetBalanceMoney,
  GetIsOk,
  Getkoujian,
  Refuse,
  Finshflow,
  
};
